// extracted by mini-css-extract-plugin
export default {"main_section":"FaqSection_main_section__FjHsE","aboutChild":"FaqSection_aboutChild__OPd6w","btn":"FaqSection_btn__u4lhy","faqSection":"FaqSection_faqSection__Ja480"};